import Reveal from "@/components/feature/Reveal";
import { LINKS } from "@/constants/site";
import { dishes, dishesNote } from "@/mocks/dishes";

export default function ChefPicks() {
  return (
    <section id="recomendados" className="w-full bg-ink py-14 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <Reveal className="text-center">
          <h2 className="font-serif text-4xl text-peach md:text-6xl">Recomendados del chef</h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-sand md:text-lg">
            Los platos que no te puedes perder en CLEM.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {dishes.map((dish, index) => (
            <Reveal key={dish.id} delay={(index % 3) * 80}>
              <article className="flex h-full flex-col overflow-hidden rounded-xl2 border border-malva/40 bg-card">
                <div className="aspect-[4/3] w-full overflow-hidden">
                  <img
                    src={dish.image}
                    alt={`${dish.name} — plato de autor de CLEM by Cerón`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="flex flex-1 flex-col p-5 md:p-6">
                  <h3 className="font-serif text-[22px] leading-tight text-peach">{dish.name}</h3>
                  <p className="mt-2 text-base font-bold text-cream">{dish.price}</p>
                  <p className="mt-3 text-base leading-relaxed text-cream/85">
                    {dish.description}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12 flex flex-col items-center">
          <a
            href={LINKS.menu}
            target="_blank"
            rel="noopener"
            className="inline-flex min-h-[52px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-peach px-8 text-base font-semibold text-ink transition-colors hover:bg-[#eeb987] sm:w-auto"
          >
            <i className="ri-file-list-3-line text-lg" aria-hidden="true" />
            Ver la carta completa
          </a>
          <p className="mt-5 max-w-xl text-center text-xs leading-relaxed text-sand md:text-sm">
            {dishesNote}
          </p>
        </Reveal>
      </div>
    </section>
  );
}